import React from 'react';
import { siteData } from '../data';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <div className="relative h-[60vh] md:h-[75vh] lg:h-[85vh] flex items-start justify-center pt-24 md:pt-32 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={siteData.hero.image}
          alt="Thai Massage"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mt-32 md:mt-60 lg:mt-80"
      >
        {/* Watermark Logo */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-[-1] opacity-10">
          <img 
            src="https://assets.auxodev.dk/assets/827bf07b-63d5-4b3e-a53e-0e890a6a1d87/b73d13a3-9cbb-497b-973b-95f80ba16559.png" 
            alt="" 
            className="w-full max-w-lg object-contain"
          />
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl font-prata font-medium text-white tracking-tight mb-4 uppercase">
          {siteData.hero.title}
        </h1>
        <p className="text-xl sm:text-2xl text-stone-200 mb-4 max-w-2xl mx-auto">
          {siteData.hero.subtitle}
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="#behandlinger"
            className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-medium rounded-full text-white bg-[#b0a697] hover:bg-[#b0a697]/90 transition-all transform hover:scale-105 shadow-xl"
          >
            {siteData.hero.cta}
          </a>
          <Link
            to="/kontakt"
            className="inline-flex items-center justify-center px-8 py-4 bg-[#ffbd59] text-lg font-medium rounded-full text-white hover:bg-[#ffbd59]/90 transition-all transform hover:scale-105 shadow-xl"
          >
            Kontakt os
          </Link>
        </div>
      </motion.div>

    </div>
  );
}
